/**
 * Password-complexity pattern — the single source of truth for the auth screens
 * (sign up, sign in, reset password), which previously each inlined an identical
 * copy of this regex.
 *
 * As ENFORCED: at least 8 characters, at least one letter (EITHER case), one digit
 * and one special character.
 *
 * NOTE (finding 65): the on-screen policy text claims a separate UPPERCASE and
 * lowercase letter are both required, but `(?=.*[a-zA-Z])` only requires one letter
 * of either case — so an all-lowercase password is accepted. The message over-states
 * what is enforced. Do NOT tighten this regex to match the message without first
 * addressing finding 48 (sign-in wrongly re-applies these creation-time rules as a
 * login gate, so tightening would lock out existing users).
 */
export const PASSWORD_PATTERN = /^.*(?=.{8,})(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W]).*$/;

/** True when `value` satisfies the enforced password-complexity pattern. */
export function isPasswordValid(value: string | null | undefined): boolean {
  return !!value && PASSWORD_PATTERN.test(value);
}
